import { AiOutlineTeam } from "react-icons/ai"
import { BiSearchAlt, BiRss, BiCodeAlt } from "react-icons/bi"
import {
  FaShieldAlt,
  FaAws,
  FaDatabase,
  FaCodeBranch,
  FaServer,
  FaGitAlt,
  FaGithub,
  FaDocker,
  FaPython,
  FaHtml5,
  FaCss3Alt,
  FaCloud,
  FaDesktop,
  FaTools,
  FaUniversity,
  FaSchool,
} from "react-icons/fa"
import { GiTiedScroll } from "react-icons/gi"
import { HiLightningBolt, HiCube, HiCollection, HiServer } from "react-icons/hi"
import { IconType } from "react-icons/lib"
import {
  MdApi,
  MdIntegrationInstructions,
  MdStorage,
  MdDeviceHub,
  MdDashboard,
  MdSpeed,
  MdExtension,
} from "react-icons/md"
import {
  SiReact,
  SiNextdotjs,
  SiVuedotjs,
  SiJquery,
  SiAntdesign,
  SiShadcnui,
  SiNodedotjs,
  SiNestjs,
  SiExpress,
  SiMysql,
  SiPostgresql,
  SiSqlite,
  SiGithubactions,
  SiAlgolia,
  SiRedis,
  SiJavascript,
  SiTypescript,
} from "react-icons/si"

export const categoryIcons: Record<string, React.ReactNode> = {
  Frontend: <FaDesktop className="text-base" aria-hidden="true" />,
  Backend: <HiServer className="text-base" aria-hidden="true" />,
  Databases: <FaDatabase className="text-base" aria-hidden="true" />,
  "Cloud & DevOps": <FaCloud className="text-base" aria-hidden="true" />,
  Tools: <FaTools className="text-base" aria-hidden="true" />,
  Other: <MdExtension className="text-base" aria-hidden="true" />,
}

export const skillIcons: Record<string, React.ReactNode> = {
  // Frontend
  "React.js": <SiReact className="text-xs" aria-hidden="true" />,
  "Next.js": <SiNextdotjs className="text-xs" aria-hidden="true" />,
  "Vue.js": <SiVuedotjs className="text-xs" aria-hidden="true" />,
  jQuery: <SiJquery className="text-xs" aria-hidden="true" />,
  "Ant Design": <SiAntdesign className="text-xs" aria-hidden="true" />,
  "shadcn/ui": <SiShadcnui className="text-xs" aria-hidden="true" />,
  // Backend
  "Node.js": <SiNodedotjs className="text-xs" aria-hidden="true" />,
  "Nest.js": <SiNestjs className="text-xs" aria-hidden="true" />,
  "Express.js": <SiExpress className="text-xs" aria-hidden="true" />,
  "REST APIs": <MdApi className="text-xs" aria-hidden="true" />,
  "Authentication & Authorization": <FaShieldAlt className="text-xs" aria-hidden="true" />,
  "API Integration": <MdIntegrationInstructions className="text-xs" aria-hidden="true" />,
  // Databases
  MySQL: <SiMysql className="text-xs" aria-hidden="true" />,
  PostgreSQL: <SiPostgresql className="text-xs" aria-hidden="true" />,
  SQLite: <SiSqlite className="text-xs" aria-hidden="true" />,
  // Cloud & DevOps
  AWS: <FaAws className="text-xs" aria-hidden="true" />,
  Lambda: <HiLightningBolt className="text-xs" aria-hidden="true" />,
  RDS: <FaDatabase className="text-xs" aria-hidden="true" />,
  S3: <HiCube className="text-xs" aria-hidden="true" />,
  EBS: <MdStorage className="text-xs" aria-hidden="true" />,
  Batch: <HiCollection className="text-xs" aria-hidden="true" />,
  EventBridge: <MdDeviceHub className="text-xs" aria-hidden="true" />,
  "CI/CD Pipelines": <MdDashboard className="text-xs" aria-hidden="true" />,
  "GitHub Actions": <SiGithubactions className="text-xs" aria-hidden="true" />,
  "Bitbucket Pipelines": <FaCodeBranch className="text-xs" aria-hidden="true" />,
  "Linux Server Management": <FaServer className="text-xs" aria-hidden="true" />,
  // Tools
  Git: <FaGitAlt className="text-xs" aria-hidden="true" />,
  GitHub: <FaGithub className="text-xs" aria-hidden="true" />,
  OpenSearch: <BiSearchAlt className="text-xs" aria-hidden="true" />,
  Algolia: <SiAlgolia className="text-xs" aria-hidden="true" />,
  "RSS Integration": <BiRss className="text-xs" aria-hidden="true" />,
  // Other
  Redis: <SiRedis className="text-xs" aria-hidden="true" />,
  Docker: <FaDocker className="text-xs" aria-hidden="true" />,
  "Agile / Scrum": <AiOutlineTeam className="text-xs" aria-hidden="true" />,
  WebSockets: <MdApi className="text-xs" aria-hidden="true" />,
  "React Query / TanStack Query": <SiReact className="text-xs" aria-hidden="true" />,
  // Programming Languages
  JavaScript: <SiJavascript className="text-xs" aria-hidden="true" />,
  TypeScript: <SiTypescript className="text-xs" aria-hidden="true" />,
  Python: <FaPython className="text-xs" aria-hidden="true" />,
  // Generic fallback
  "Database Optimization": <FaDatabase className="text-xs" aria-hidden="true" />,
  Caching: <MdSpeed className="text-xs" aria-hidden="true" />,
  "XML Processing": <BiCodeAlt className="text-xs" aria-hidden="true" />,
  Analytics: <MdDashboard className="text-xs" aria-hidden="true" />,
  // Additional technologies from experience
  React: <SiReact className="text-xs" aria-hidden="true" />,
  "CI/CD": <MdDashboard className="text-xs" aria-hidden="true" />,
  HTML: <FaHtml5 className="text-xs" aria-hidden="true" />,
  CSS: <FaCss3Alt className="text-xs" aria-hidden="true" />,
}

export const EducationIcons: Record<string, IconType> = {
  Bachelor: FaUniversity,
  "Higher Secondary": GiTiedScroll,
  Secondary: FaSchool,
}
